import React, { Component, Fragment } from "react";
import Modal from "../Modal";
import axios from "axios";
import Button from "../../Resources/Forms/Button";
import Input from "../../Resources/Forms/Input";
import { LocationTargetIcon } from "../../Resources/Icons/Collections";
import { google_key } from "../../app-config";
import { POST } from "../../Utils/api";
import withAppData from "../../HOC/withAppData";

let apiKey = google_key;
let map;
let marker;
let infowindow;
let placesInput;
let mapCenterMarker;

class UpdateCustomerLocation extends Component {
	constructor(props) {
		super(props);
		this.addressRef = React.createRef();
		this.state = {
			updatingAddress: false,
			googleScriptsLoaded: false,
			address: "",
			selectedAddress: "",
			locationTargetColor: "#5e7079",
		};
	}

	componentDidMount() {
		this.setState(
			{ address: this.props.address, selectedAddress: this.props.address },
			() => {
				if (window.google && window.google.maps && window.google.maps.places) {
					this.setState(
						{
							longitude: this.props.longitude,
							latitude: this.props.latitude,
							googleScriptsLoaded: true,
						},
						() => {
							this.initMap();
						},
					);
				} else {
					let script = document.createElement("script");
					script.onload = () => {
						this.setState(
							{
								longitude: this.props.longitude,
								latitude: this.props.latitude,
								googleScriptsLoaded: true,
							},
							() => {
								this.initMap();
							},
						);
					};
					script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
					document.getElementsByTagName("head")[0].appendChild(script);
				}
			},
		);
	}

	resetLocation = () => {
		this.setState(
			{
				longitude: this.props.initialLocation.longitude,
				latitude: this.props.initialLocation.latitude,
				address: this.props.initialLocation.address,
				selectedAddress: this.props.initialLocation.address,
			},
			() => {
				marker.setPosition(
					new window.google.maps.LatLng(
						this.state.latitude,
						this.state.longitude,
					),
				);
			},
		);
	};

	render() {
		return (
			<div className="update-customer-location">
				<Modal
					header={"Update Customer Location"}
					closeModal={this.props.close}
					maxHeight={"420px"}
				>
					{this.state.googleScriptsLoaded ? (
						<Fragment>
							<div style={{ marginBottom: "60px" }}>
								<div className="update-customer-location-container">
									<div className="update-customer-location-container-current flex align-center">
										{this.state.updatingAddress ? (
											<span className="loading-circle"></span>
										) : (
											<Input
												value={this.state.address}
												onChange={e => this.editAddress(e)}
												size={"small"}
												autoFocus={true}
												spellCheck={false}
												id="place-autocomplete"
												disabled={!this.state.googleScriptsLoaded}
												errorText={
													this.state.showBoundError
														? this.state.address
															? "This location is too far from your current location"
															: "Please add address"
														: ""
												}
												ref={this.addressRef}
											/>
										)}
									</div>
									<div className="relative">
										<div
											className="update-customer-location-map"
											id="update-customer-location-map"
										></div>
										{this.props.initialLocation.longitude && (
											<div
												className="update-customer-location-container-current-reset"
												title={"Reset location"}
												onMouseEnter={() =>
													this.setState({ locationTargetColor: "#015fd1" })
												}
												onMouseLeave={() =>
													this.setState({ locationTargetColor: "#5e7079" })
												}
												onClick={() => this.resetLocation()}
											>
												<LocationTargetIcon
													height={"15px"}
													width={"15px"}
													color={this.state.locationTargetColor}
												/>
											</div>
										)}
									</div>
									<div className="update-customer-location-help flex align-center">
										<i>
											Drag the{" "}
											<svg viewBox="0 0 342 512" fill="none" height={"13px"}>
												<path
													d="M171 0C76.896 0 .333 76.563.333 170.667c0 28.25 7.063 56.26 20.49 81.104L161.667 506.5A10.653 10.653 0 00171 512c3.885 0 7.458-2.104 9.333-5.5l140.896-254.813c13.375-24.76 20.438-52.771 20.438-81.021C341.667 76.563 265.104 0 171 0zm0 256c-47.052 0-85.333-38.281-85.333-85.333S123.948 85.334 171 85.334s85.333 38.281 85.333 85.333S218.052 256 171 256z"
													fill="#EA4335"
												/>
												<circle cx={171.5} cy={170.5} r={86.5} fill="#811411" />
											</svg>{" "}
											around, click the map or edit the address above to update
											customer's location
										</i>
									</div>
								</div>
							</div>
							<div className="modal-submit">
								<Button
									type={"primary"}
									text={"Update"}
									noMargin={true}
									loading={this.state.loading}
									disabled={
										!this.state.address ||
										this.state.updatingAddress ||
										this.state.showBoundError ||
										this.state.updatingCoordinates
									}
									onClick={() => this.updateAddress()}
								/>
							</div>
						</Fragment>
					) : (
						<div className="mapcontainer-maploader">
							<div className="mapcontainer-maploader-text">
								Getting customer's location
							</div>
							<div className="mapcontainer-maploader-icon">
								<svg viewBox="0 0 342 512" fill="none">
									<path
										d="M171 0C76.896 0 .333 76.563.333 170.667c0 28.25 7.063 56.26 20.49 81.104L161.667 506.5A10.653 10.653 0 00171 512c3.885 0 7.458-2.104 9.333-5.5l140.896-254.813c13.375-24.76 20.438-52.771 20.438-81.021C341.667 76.563 265.104 0 171 0zm0 256c-47.052 0-85.333-38.281-85.333-85.333S123.948 85.334 171 85.334s85.333 38.281 85.333 85.333S218.052 256 171 256z"
										fill="#EA4335"
									/>
									<circle cx={171.5} cy={170.5} r={86.5} fill="#811411" />
								</svg>
							</div>
						</div>
					)}
				</Modal>
			</div>
		);
	}

	editAddress = e => {
		this.setState({ address: e.target.value }, () => {});
	};

	initMap = () => {
		const { userLocation } = this.props.context;
		const position = {
			lat: this.state.latitude,
			lng: this.state.longitude,
		};
		let circleCenter = new window.google.maps.LatLng(
			userLocation.latitude || this.props.latitude,
			userLocation.longitude || this.props.longitude,
		);
		let circle = new window.google.maps.Circle({
			radius: 300,
			center: circleCenter,
		});
		let bounds = circle.getBounds();
		map = new window.google.maps.Map(
			document.getElementById("update-customer-location-map"),
			{
				center: position,
				clickableIcons: false,
				zoom: 1,
				restriction: {
					latLngBounds: bounds,
					strictBounds: true,
				},
			},
		);
		marker = new window.google.maps.Marker({
			position: position,
			map: map,
			draggable: true,
		});
		mapCenterMarker = new window.google.maps.Marker({
			position: position,
			map: map,
			icon: "Images/current-location.svg",
		});
		infowindow = new window.google.maps.InfoWindow({
			content:
				"Drag this around, click the map or edit the address above to update customer's location",
			maxWidth: 245,
		});
		placesInput = document.getElementById("place-autocomplete");
		let autocomplete = new window.google.maps.places.Autocomplete(placesInput);
		autocomplete.bindTo("bounds", map);
		map.addListener("click", e => {
			this.setState(
				{ longitude: e.latLng.lng(), latitude: e.latLng.lat() },
				() => {
					infowindow.close();
					this.getAddressAndSetMarkerPosition();
				},
			);
		});
		marker.addListener("dragend", e => {
			this.setState(
				{ longitude: e.latLng.lng(), latitude: e.latLng.lat() },
				() => {
					this.getAddress();
				},
			);
		});
		mapCenterMarker.addListener("click", e => {
			this.setState(
				{ longitude: e.latLng.lng(), latitude: e.latLng.lat() },
				() => {
					this.getAddressAndSetMarkerPosition();
				},
			);
		});
		marker.addListener("dragstart", e => {
			infowindow.close();
		});
		autocomplete.addListener("place_changed", () => {
			this.setState({ updatingCoordinates: true }, () => {
				infowindow.close();
				let place = autocomplete.getPlace();
				if (!place.geometry) {
					this.props.context.showAlert(
						"No details available for input: '" + place.name + "'",
					);
					this.setState({ updatingCoordinates: false });
					return;
				} else {
					this.setState(
						{
							address: place.formatted_address,
							selectedAddress: place.formatted_address,
							updatingCoordinates: false,
						},
						() => {
							if (place.geometry && place.geometry.location) {
								let placeLocation = place.geometry.location;
								marker.setPosition(
									new window.google.maps.LatLng(
										placeLocation.lat(),
										placeLocation.lng(),
									),
								);
								if (!this.checkIfMarkerIsInBounds()) {
									this.setState({ showBoundError: true }, () => {});
								} else {
									this.setState({
										longitude: placeLocation.lng(),
										latitude: placeLocation.lat(),
									});
								}
							}
						},
					);
				}
			});
		});
		setTimeout(() => {
			// infowindow.open(map, marker);
		}, 1000);
	};

	getAddressAndSetMarkerPosition = () => {
		this.getAddress();
		marker.setPosition(
			new window.google.maps.LatLng(this.state.latitude, this.state.longitude),
		);
	};

	checkIfMarkerIsInBounds = () => {
		//check if user has permission to update location remotely
		if (this.props.allowUpdate || this.props.context.hasPermission(223, 3)) {
			return true;
		}
		return map && marker
			? map.getBounds().contains(marker.getPosition())
			: false;
	};

	getAddress = () => {
		// cancel the previous request to prevent multiple api requests
		if (typeof this._source !== typeof undefined) {
			this._source.cancel("I just cancelled the previous request");
		}
		// save the new request for cancellation
		this._source = axios.CancelToken.source();
		const config = {
			cancelToken: this._source.token,
		};
		this.setState({ updatingAddress: true, showBoundError: false }, () => {
			axios
				.get(
					`https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.state.latitude},${this.state.longitude}&key=${apiKey}`,
					config,
				)
				.then(resp => {
					if (resp.data.status === "OK") {
						let accurateResultIndex = 0;
						let results = resp.data.results;
						if (results.length > 0) {
							results.forEach((el, i) => {
								if (
									el.types &&
									el.types.length === 1 &&
									el.types[0] === "street_address"
								) {
									accurateResultIndex = i;
								}
							});

							this.setState(
								{
									address: results[accurateResultIndex].formatted_address,
									selectedAddress:
										results[accurateResultIndex].formatted_address,
									updatingAddress: false,
								},
								() => {
									this.logRequest(results[accurateResultIndex]);
								},
							);
						}
					} else {
						if (resp.data.error_message) {
							this.logRequest(null, resp.data.error_message);
						}
					}
				})
				.catch(error => {
					this.setState({ updatingAddress: false });
				});
		});
	};

	logRequest = (geocodeResult, errorMessage) => {
		try {
			const data = {
				address: errorMessage ? "" : geocodeResult.formatted_address,
				longitude: errorMessage ? "" : geocodeResult.geometry.location.lng,
				latitude: errorMessage ? "" : geocodeResult.geometry.location.lat,
				purpose: `Update customer location in address book ${
					errorMessage ? ` - ${errorMessage}` : ""
				}`,
				source: errorMessage ? 3 : 2,
				type_id: "",
			};
			POST("logger/AddUIGeoLocationLogs", data);
		} catch (error) {
			console.log(error);
		}
	};

	updateAddress = () => {
		this.setState({ loading: true }, () => {
			setTimeout(
				() => {
					const canUpdateLocationRemotely =
						this.props.allowUpdate || this.props.context.hasPermission(223, 3);
					const { userLocation } = this.props.context;
					const longitude =
						canUpdateLocationRemotely || !userLocation.longitude
							? this.state.longitude
							: userLocation.longitude;
					const latitude =
						canUpdateLocationRemotely || !userLocation.latitude
							? this.state.latitude
							: userLocation.latitude;
					this.props.updateLocation(
						longitude,
						latitude,
						this.state.selectedAddress,
					);
				},
				this.state.selectedAddress === this.state.address ? 500 : 50,
			);
		});
	};
}

export default withAppData(UpdateCustomerLocation);
